import {RendererProps} from "../RendererProps";
import {ReactElement} from "react";
import {ensureNotObject} from "../common";

export function RenderDeleteUnitType(props: RendererProps): ReactElement {
    const unitTypeId = props.variables["unitTypeId"];
    return <div>Deleted Unit Type: {ensureNotObject(unitTypeId)}</div>;
}